<template>
  <div class="embedded-website-container">
    <iframe :src="websiteUrl" class="embedded-website"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      websiteUrl: "https://wheelseye.com/fo/login",
    };
  },
};
</script>
<style>
audio:not(.md-image), img:not(.md-image), svg:not(.md-image), object:not(.md-image), embed:not(.md-image), canvas:not(.md-image), video:not(.md-image), iframe:not(.md-image) {
    height: 100%;
}
.embedded-website-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; /* Adjust this value based on the aspect ratio of the iframe content */
}

.embedded-website {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// WheelsTrack.vue?b68a543a